/** Large monospace time readout shared by the countdown and stopwatch. */
export function TimeDisplay({
  value,
  finished = false,
  label,
}: {
  value: string;
  finished?: boolean;
  label?: string;
}) {
  return (
    <div
      role="timer"
      aria-atomic="true"
      aria-label={label}
      className={`text-center font-mono text-6xl font-bold leading-none tabular-nums sm:text-7xl md:text-8xl ${
        finished ? "animate-pulse text-destructive" : "pct-result"
      }`}
    >
      {value}
    </div>
  );
}
